import { render } from "./BookPraise.vue?vue&type=template&id=b6a8b8d0&scoped=true"
import script from "./BookPraise.vue?vue&type=script&lang=js"
export * from "./BookPraise.vue?vue&type=script&lang=js"

import "./BookPraise.vue?vue&type=style&index=0&id=b6a8b8d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a8b8d0"]])

export default __exports__